import { useEffect, useState } from 'react';
import styles from './index.module.scss';

export default function CardInfoBtn({ className, text, desc }: any) {
    const [show, setShow] = useState(false);

    const handleClose = (e: any) => {
        if (show) {
            e.stopPropagation();
            setShow(false);
        }
    };
    useEffect(() => {
        if (typeof window !== 'undefined') {
            window.addEventListener('click', () => {
                setShow(false);
            });
        }
    });
    return (
        <div
            className={`${styles.comp} ${className}`}
            onClick={(e) => {
                document.body.click();
                e.stopPropagation();
                setShow(true);
            }}
        >
            <span className="btn-text">{text}</span>
            <svg
                className={`${show ? 'show' : ''}`}
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
                onClick={handleClose}
            >
                <path
                    d="M10 17.5C14.1421 17.5 17.5 14.1421 17.5 10C17.5 5.85786 14.1421 2.5 10 2.5C5.85786 2.5 2.5 5.85786 2.5 10C2.5 14.1421 5.85786 17.5 10 17.5Z"
                    fill="url(#paint0_linear_12547_15948)"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M10.7615 6.33879C10.7615 5.92457 10.4258 5.58887 10.0115 5.58887C9.59733 5.58887 9.26163 5.92457 9.26163 6.33879V9.20727H6.38176C5.96754 9.20727 5.63184 9.54297 5.63184 9.95718C5.63184 10.3714 5.96754 10.7071 6.38176 10.7071H9.26163V13.5756C9.26163 13.9898 9.59733 14.3255 10.0115 14.3255C10.4258 14.3255 10.7615 13.9898 10.7615 13.5756V10.7071H13.6186C14.0328 10.7071 14.3685 10.3714 14.3685 9.95718C14.3685 9.54297 14.0328 9.20727 13.6186 9.20727H10.7615V6.33879Z"
                    fill="#18191B"
                />
                <defs>
                    <linearGradient id="paint0_linear_12547_15948" x1="-1.671" y1="14.767" x2="14.1976" y2="21.3717" gradientUnits="userSpaceOnUse">
                        <stop stopColor="#FFDC7E" />
                        <stop offset="0.407071" stopColor="#FFD35B" />
                        <stop offset="1" stopColor="#FFC520" />
                    </linearGradient>
                </defs>
            </svg>
            <div className={`btn-desc ${show ? 'show' : ''}`}>
                <span>{desc}</span>
            </div>
        </div>
    );
}
